import React from 'react'
import { VehiclePhotosUpload } from '../VehiclePhotosUpload'
import { VehicleSocialMedia } from '../VehicleSocialMedia'

interface VehicleRegistrationStep5MediaProps {
  formData: {
    photos: File[]
    videoUrl?: string
    instagramUrl?: string
    youtubeUrl?: string
    tiktokUrl?: string
    facebookUrl?: string
  }
  errors: Record<string, string>
  primaryPhotoIndex: number
  onInputChange: (field: string, value: any) => void
  onPrimaryPhotoChange: (index: number) => void
}

export const VehicleRegistrationStep5Media: React.FC<VehicleRegistrationStep5MediaProps> = ({
  formData,
  errors,
  primaryPhotoIndex,
  onInputChange,
  onPrimaryPhotoChange,
}) => {
  return (
    <div onClick={(e) => e.stopPropagation()} className="space-y-4">
      <VehiclePhotosUpload
        photos={formData.photos}
        onPhotosChange={(photos) => onInputChange('photos', photos)}
        primaryPhotoIndex={primaryPhotoIndex}
        onPrimaryPhotoChange={onPrimaryPhotoChange}
        error={errors.photos}
      />

      <VehicleSocialMedia
        videoUrl={formData.videoUrl}
        instagramUrl={formData.instagramUrl}
        youtubeUrl={formData.youtubeUrl}
        tiktokUrl={formData.tiktokUrl}
        facebookUrl={formData.facebookUrl}
        onFieldChange={onInputChange}
      />
    </div>
  )
}
